module.exports = __webpack_public_path__ + "static/load-many-circles-130228bea29ec862924aa8629e7d5718.png";